var React = require('react');

var styles = {"progress-bar-wrapper":"_53Ji7","step-progress-bar":"_1Lo2h","progress-step":"_2Jtxm","step-index":"_2kL0S","step-icon":"_2JvrO","step-label":"_1hzhf","step-label-subtitle":"_1ixJ3","completed":"_2ZUAI","spring-down":"_3SDnc","current":"_35Ago","spring-up":"_JAh3L","has-error":"_1CcaK","shake":"_1ujce","step-content":"_2_g61","step-buttons":"_3uApM","step-action-btn":"_2pGos","action-btn-secondary":"_3CDiP","action-btn-primary":"_hsN1w","disabled":"_2RWmX"};

var StepStates;

(function (StepStates) {
    StepStates["NOT_STARTED"] = "not_started";
    StepStates["CURRENT"] = "current";
    StepStates["ERROR"] = "error";
    StepStates["COMPLETED"] = "completed";
})(StepStates || (StepStates = {}));

function Step (props) {
    var state = props.state,
        index = props.index,
        label = props.label,
        subtitle = props.subtitle;
    return React.createElement("li", {
        key: index,
        className: "" + styles['progress-step'] + (state === StepStates.COMPLETED ? " " + styles.completed : '') + (state === StepStates.CURRENT ? " " + styles.current : '') + (state === StepStates.ERROR ? " " + styles['has-error'] : '')
    }, state === StepStates.COMPLETED && React.createElement("span", {
        className: styles['step-icon']
    }, React.createElement("svg", {
        width: "1.5rem",
        viewBox: "0 0 13 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
        d: "M1 3.5L4.5 7.5L12 1",
        stroke: "white",
        strokeWidth: "1.5"
    }))), state === StepStates.ERROR && React.createElement("span", {
        className: styles['step-icon']
    }, "!"), state !== StepStates.COMPLETED && state !== StepStates.ERROR && React.createElement("span", {
        className: styles['step-index']
    }, index + 1), React.createElement("div", {
        className: styles['step-label']
    }, label, subtitle && React.createElement("div", {
        className: styles['step-label-subtitle']
    }, subtitle)));
}

function StepProgressBar(props) {
    var current = props.current,
        onSubmit = props.onSubmit,
        children = props.children,
        errors = props.errors;

    var numChildren = React.Children.count(children),
        modifiedChildren = React.Children.map(children, (child, index) => {
            if (!child) return;
            return /*#__PURE__*/React.cloneElement(child, {
                state: errors[index] ? StepStates.ERROR : current === index ? StepStates.CURRENT : current > index ? StepStates.COMPLETED : StepStates.NOT_STARTED,
                step: index + 1,
                last: index === numChildren - 1,
                index: index,
            });
        })
    var panels = React.Children.map(children, (child, index) => {
        if (!child) return;
        return /*#__PURE__*/React.createElement('div', {
            role: 'panel',
            style: {
                display: current === index ? 'flex' : 'none',
                flexDirection: "column"
            }
        }, child.props.children);
    })


    // eslint-disable-next-line
    function submitHandler() {
        onSubmit();
    }

    // function _nextHandler() {
    //     if (currentIndex === steps.length - 1) {
    //         return;
    //     }
    //
    //     var isStateValid = true;
    //     var stepValidator = state[currentIndex].validator;
    //
    //     if (stepValidator) {
    //         isStateValid = stepValidator();
    //     }
    //
    //     dispatch({
    //         type: 'next',
    //         payload: {
    //             index: isStateValid ? currentIndex + 1 : currentIndex,
    //             state: isStateValid ? StepStates.CURRENT : StepStates.ERROR
    //         }
    //     });
    //
    //     if (isStateValid) {
    //         setCurrentIndex(currentIndex + 1);
    //     }
    // }


    // function prevHandler() {
    //     if (currentIndex === 0) {
    //         return;
    //     }
    //
    //     dispatch({
    //         type: 'previous',
    //         payload: {
    //             index: currentIndex - 1,
    //             state: StepStates.CURRENT
    //         }
    //     });
    //     setCurrentIndex(currentIndex - 1);
    // }

    return React.createElement("div", {
        className: styles['progress-bar-wrapper']
    }, React.createElement("ul", {
        className: styles['step-progress-bar'],
        style: {marginBottom: '5rem'}
    }, modifiedChildren), panels)
}

module.exports = {StepProgressBar, Step}
